var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-alert',{attrs:{"title":"This page hasn&rsquo;t been translated into English yet","description":"But we&rsquo;re working on&nbsp;it.","is-visible":_vm.isVisible},on:{"closeClick":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }